import { ComponentType, Suspense } from 'react';
import SuspenseSpinner from './SuspenseSpinner';

const SuspenseLoaderWrapper = <P extends object>(Component: ComponentType<P>) => (props: P) => (
  <Suspense fallback={<SuspenseSpinner />}>
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <Component {...props} />
  </Suspense>
);

export default SuspenseLoaderWrapper;
